import Jquery from 'jquery';
window.jQuery = window.$ = Jquery;

import validate from 'jquery-validation'

validate.validator.addMethod('rightEmail', function (val, el) {
    return (/^([a-zA-Z0-9_\-]+\.)*[a-zA-Z0-9_\-]+@([a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]\.)+[a-zA-Z]{2,4}$/i.test(val));
}, 'Введите корректный e-mail');
validate.validator.addMethod('rightPhone', function (val, el) {
    console.log(val, '/^\\+?[0-9\\-\\s()]+$/i')
    return (/^\+?[0-9\-\s()]+$/i.test(val));
}, 'Введите корректный телефон');

validate.validator.messages.minlength = 'Не менее {0} символов';
validate.validator.messages.maxlength = 'Не более {0} символов';
validate.validator.messages.required = 'Нужно заполнить';
validate.validator.messages.min = 'Должно быть не меньше {0}';
validate.validator.messages.max = 'Должно быть не больше {0}';
